export default "__VITE_ASSET__COfCG3gf__"